import Header from "./components/Header";
import Hero from "./components/Hero";
import NoticeBar from "./components/NoticeBar";
import CurrentEntries from "./components/CurrentEntries";
import HistoryTimeline from "./components/HistoryTimeline";
import MigrationArchive from "./components/MigrationArchive";
import GuideTrust from "./components/GuideTrust";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-950">
      <Header />
      <main>
        <Hero />
        <NoticeBar />
        <CurrentEntries />
        <HistoryTimeline />
        <MigrationArchive />
        <GuideTrust />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
    </div>
  );
}